<template>
    <div
    class="modal right fade trader-info"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">UPDATE HOLDING</h5>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form>
                <div class="form-row">
                    <div class="form-group col-md-6 required">
                        <label for="inputEmail4">Account</label>
                        <input  type="text" class="form-control" id="inputEmail4" placeholder="account"  v-model="inventoryData.account" >
                    </div>
                    <div class="form-group col-md-6 required">
                        <label for="inputLast">Cusip</label>
                        <input type="text" class="form-control" id="inputLast" placeholder="cusip"  v-model="inventoryData.cusip" >
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 required">
                        <label for="inputLast">Quantity</label>
                        <input type="text" class="form-control" id="inputLast" placeholder="quantity"  v-model.number="inventoryData.quantity" > 
                    </div>    
                    <div class="form-group col-md-6 required">
                        <label for="inputLocation">cost</label>
                        <input type="number" class="form-control" placeholder="cost"  v-model="inventoryData.cost">
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 required">
                        <label for="inputLast">Bought Date</label>
                        <datepicker v-model="inventoryData.boughtDate" placeholder="mm/dd/yyyy" typeable name="callDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker> 
                        <!-- <input type="text" class="form-control" id="inputLast" placeholder="boughtDate"  v-model="inventoryData.boughtDate" >  -->
                    </div>    
                    <div class="form-group col-md-6 required">
                        <label for="inputLocation">Maturity Date</label>
                        <datepicker v-model="inventoryData.maturityDate" placeholder="mm/dd/yyyy" typeable name="callDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker> 
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label for="inputLast">S&P Rating</label>
                        <!-- <input type="text" class="form-control" id="inputLast" placeholder="ratingSP"  v-model="inventoryData.ratingSP" >  -->
                        <select class="form-control" id="exampleFormControlSelect1"  v-model="inventoryData.ratingSP">
                            <option value>Please select</option>
                            <option
                            v-for="sp in spRatingConstants"
                            :key="sp"
                            v-bind:value="sp"
                            >{{sp}}</option>
                        </select>
                    </div>    
                    <div class="form-group col-md-6">
                        <label for="inputLocation">Moody's Rating</label>
                        <!-- <input type="text" class="form-control" id="inputLast" placeholder="ratingMoody"  v-model="inventoryData.ratingMoody" >  -->
                        <select class="form-control" id="exampleFormControlSelect1"  v-model="inventoryData.ratingMoody">
                            <option value>Please select</option>
                            <option
                            v-for="moody in moodyConstants"
                            :key="moody"
                            v-bind:value="moody.toUpperCase()"
                            >{{moody}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-6">
                        <label for="accountno">Is Margin</label>
                        <div class="input-group mb-3">
                            <select class="form-control"  v-model="inventoryData.isMargin" >
                                <option value="YES">YES</option>
                                <option value="NO">NO</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                <p v-if="errors.length">
                    <ul>
                    <li class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</li>
                    </ul>
                </p>
                <div class="modal-footer bid">
                    <button type="button" class="btn btn-secondary"  @click="$emit('close')">Close</button>
                    <button type="button" class="btn btn-primary" @click="updateInventory()">UPDATE</button>
                </div>
            </form>
        </div>
        </div>
    </div>
    </div>
</template>

<script>
    import authService from "@/authService";
    import config from "@/config";
    import Datepicker from 'vuejs-datepicker';
    import moodyConstants from "@/moodyRatingConstants";
    import spRatingConstants from "@/spRatingConstants";

    export default {
        name: 'inventoryerrormodal',
        components :{
            Datepicker
        },
        props: ['inventoryData'],
        data() {
            return {
                loading : false,
                errors: [],
                spRatingConstants:spRatingConstants,
                moodyConstants: moodyConstants,
            };
        },
        methods: {   
            updateInventory(){
                let isValid = this.checkForm();
                if (isValid) {
                    this.loading = true;
                    var addData = { ...this.inventoryData};
                    const auth = {
                        headers: { 'org-token' : authService.getOrgToken()  }
                    };
                    if(this.inventoryData.isMargin  == 'YES'){
                        addData.isMargin  = true
                    }else{
                        addData.isMargin  = false
                    }
                    this.$http
                    .put(config.baseUrlBidSide + "/inventory/update-waiting-inventory", addData, auth)
                    .then(() => {
                        this.loading = false;
                        this.$root.$emit("invadded");              
                        this.$emit('close');               
                    })
                    .catch(() => {
                        this.loading = false;              
                    });
                }
            },
            checkForm(){
                this.errors = [];
                if (!this.inventoryData.account) {
                    this.errors.push("Account is required.");
                    return false;
                }
                if (!this.inventoryData.cusip) {
                    this.errors.push("Cusip is required.");
                    return false;
                }
                if (!this.inventoryData.quantity) {
                    this.errors.push("Quantity is required.");
                    return false;
                }
                if (!this.inventoryData.boughtDate) {
                    this.errors.push("Bought Date is required.");
                    return false;
                }
                if (!this.inventoryData.cost) {
                    this.errors.push("Cost is required.");
                    return false;
                }
                if (!this.inventoryData.maturityDate) {
                    this.errors.push("Maturity Date is required.");
                    return false;
                }
                // if (!this.inventoryData.ratingSP) {
                //     this.errors.push("S&P rating is required.");
                //     return false;
                // }
                // if (!this.inventoryData.ratingMoody) {
                //     this.errors.push("Moody's rating is required.");
                //     return false;
                // }
                return true
            }

        }
    };
    </script>